import { CommonButton } from 'components/Buttons';
import React from 'react';
import { useDispatch } from 'react-redux';
import services from 'services';
import actions from 'state/actions';
import utils from 'utils';
import { actionType, modalActionType } from 'utils/constants';

const Glossary = () => {
  const t = utils.intl.useTranslator();
  const dispatch = useDispatch();

  const getGlossary = async () => {
    try {
      const { data } = await services.getDownloadableManuals();
      dispatch(
        actions.modal.openModal(modalActionType.documents.GLOSSARY, {
          manuals: data,
        }),
      );
    } catch (e) {
      console.error(e);
      utils.app.notify('fail', t('error-glossary'), 10000);
    }
  };

  return (
    <CommonButton
      id="glossary-btn"
      action={() => getGlossary()}
      scope="tertiary"
      value={t(actionType.GLOSSARY)}
      customIcon="file-pdf"
    />
  );
};

export default Glossary;
